import React from 'react';
import { ReactComponent as House } from '../../../assets/images/svg/house.svg';
import { ReactComponent as Building } from '../../../assets/images/svg/building.svg';
import { ReactComponent as MapPinArea } from '../../../assets/images/svg/map-pin-area.svg';

export const ADDRESS_TAG_TYPES = {
  HOME: 1,
  OFFICE: 2,
  OTHER: 3,
};

export default {
  [ADDRESS_TAG_TYPES.HOME]: 'Home',
  [ADDRESS_TAG_TYPES.OFFICE]: 'Office',
  [ADDRESS_TAG_TYPES.OTHER]: 'Other',
};

export const ADDRESS_TAG_TYPES_ICONS = {
  [ADDRESS_TAG_TYPES.HOME]: <House />,
  [ADDRESS_TAG_TYPES.OFFICE]: <Building />,
  [ADDRESS_TAG_TYPES.OTHER]: <MapPinArea />,
};
